import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import BEMHelper from '@ynap/bem-helper'
import { reduxForm, formValues, Field as ReduxFormField } from 'redux-form'
import Field from '@ynap/field'
import { PasswordInput } from '@ynap/password-input'
import { SimpleAsyncButton } from '@ynap/button'
import Notification from '@ynap/notification'
import { submitAndCollateErrorsPromise, onSubmitFail } from '@ynap/form-utils'
import track from 'react-tracking'
import { trackEditPassword } from '../analytics'
import validate from './validate'
import collateErrors from './collateErrors'
import { withOptimizely } from '@ynap/optimizely-utils'

const bem = new BEMHelper('ChangePasswordForm')

@track()
export class ChangePasswordForm extends PureComponent {
    constructor(props) {
        super(props)
        this.onSubmit = this.onSubmit.bind(this)
    }

    static propTypes = {
        className: PropTypes.string,
        form: PropTypes.string,
        handleSubmit: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        submitting: PropTypes.bool,
        messages: PropTypes.shape({
            changePasswordForm: PropTypes.shape({
                currentPassword: PropTypes.func.isRequired,
                newPassword: PropTypes.func.isRequired,
                passwordRequirements: PropTypes.func.isRequired,
                update: PropTypes.func.isRequired,
            }).isRequired,
            errors: PropTypes.shape({
                required: PropTypes.func.isRequired,
                authenticationError: PropTypes.func.isRequired,
                passwordsMatch: PropTypes.func.isRequired,
                reuseOldPassword: PropTypes.func.isRequired,
                containsLogonId: PropTypes.func.isRequired,
                generic: PropTypes.func.isRequired,
                global: PropTypes.func.isRequired,
            }).isRequired,
        }).isRequired,
        locale: PropTypes.shape({
            language: PropTypes.string,
        }),
    }

    @track((props, state, methodArgs, promiseArgs) => {
        const { optimizely } = props

        const err = promiseArgs[1]

        if (!err) {
            optimizely?.track('account_updatedpassword')
        }

        return trackEditPassword()
    })
    onSubmit(values, delay = undefined) {
        const { onSubmit } = this.props
        return submitAndCollateErrorsPromise(onSubmit(values, delay), values, this.props)
    }

    render() {
        const { className, form, handleSubmit, submitting, error, children, messages } = this.props

        return (
            <form id={form} className={bem(null, { submitting }, className)} onSubmit={handleSubmit(this.onSubmit)}>
                <div className={bem('fieldsWrapper')}>
                    <Field
                        component={PasswordInput}
                        name="x_logonPasswordCurrent"
                        label={messages.changePasswordForm.currentPassword()}
                    />
                    <Field
                        component={PasswordInput}
                        name="logonPassword"
                        label={messages.changePasswordForm.newPassword()}
                        help={messages.changePasswordForm.passwordRequirements()}
                    />
                </div>

                <div className={bem('buttonWrapper')}>
                    <SimpleAsyncButton
                        type="submit"
                        loading={submitting}
                        className={bem('submit')}
                        copy={messages.changePasswordForm.update()}
                    />
                </div>

                {error ? <Notification type="error" message={error} className={bem('error')} /> : null}

                {children}
            </form>
        )
    }
}

export default withOptimizely(
    reduxForm({ form: 'changePassword', validate, collateErrors, onSubmitFail })(ChangePasswordForm)
)
